import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { mediaQuery } from '../../utils/media';
import {css} from 'styled-components';

const MainContainer = ({
    children,
    isAdmin,
}) => {

    const media = mediaQuery();
    const { isDesktop } = media;

    return <Main
        isDesktop={isDesktop}
        isAdmin={isAdmin}
    >
        {children}
    </Main>;
};

MainContainer.propTypes = {
    children: PropTypes.object,
    isAdmin: PropTypes.bool,
};

MainContainer.defaultProps = {
    isAdmin: false,
};

export default MainContainer;

const Main = styled.div`
    ${({ isDesktop, isAdmin }) => css`
        ${(!isAdmin) && `
            padding-top: ${isDesktop ? '50px' : '50px'};
        `}
    `}

`;